import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type UserRoleModel from './user-role.ts';

export default class UserRelationshipModel extends Model {
  @attr declare relationshipType: string;
  @attr declare isActive: boolean;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('user-role', { async: false, inverse: 'relationships' })
  declare role: UserRoleModel;

  @belongsTo('user-role', { async: false, inverse: null })
  declare jurisdiction: UserRoleModel;

  /**
   * Returns the company user ID from the jurisdiction's user_id
   * This matches the old role_views.company_id behavior
   */
  get companyUserId(): string | undefined {
    return this.jurisdiction?.user?.id ?? undefined;
  }

  [Type] = 'user-relationship' as const;
}
